let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("g7zq1")).then(() => parcelRequire('cGYky'));